import YaziDetay from "./Modules/Yazilar/YaziDetay";
import YaziListesi from "./Modules/Yazilar/YaziListesi";
import YaziKategorileri from "./Modules/Yazilar/YaziKategorileri";

export default {
  namespaced: true,
  modules: {
    YaziDetay,
    YaziListesi,
    YaziKategorileri,
  },
};
